import { configureStore } from '@reduxjs/toolkit';
import calcReducer from '../components/calc/calcSlice';
import formReducer from '../components/lending/formSlice';
import precalcReducer from '../components/precalc/precalcSlice';
import homeReducer from '../components/home/homeSlice';
import personReducer from '../components/calc/personSlice';
import contractReducer from '../components/calc/contractSlice';
import objectReducer from '../components/calc/objectSlice';

export const store = configureStore({
  reducer: {
    calc: calcReducer,
    form: formReducer,
    precalc: precalcReducer,
    home: homeReducer,
    person: personReducer,
    contract: contractReducer,
    object: objectReducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
